export default __webpack_public_path__ + "static/media/1.1d40c938.PNG";